import styles from "./HöhereBerufsfachschule.module.css";
import React from "react";

const HHereBerufsfachschule = () => {
  return(
      <div className={styles.container}>
          <div className="wrapperSM wrapperContent">
              <h2 className={styles.caption}>Die Zweijährige Höhere Berufsfachschule (HBFS)</h2>
              <div className="grid">
                  <div className="col-12 lg:col-3">
                      <div className={styles.label}>Aufnahme</div>
                  </div>
                  <div className="col-12 lg:col-9">
                      <div className={styles.content}>
                          <p>Aufnahmevoraussetzungen sind
                              <li>der Abschluss der zweijährigen Berufsfachschule</li>
                              <li>der Realschulabschluss</li>
                              <li>die Versetzung in eine gymnasiale Oberstufe</li>
                              Die Noten der Hauptfächer Deutsch, Englisch und Mathematik dürfen nicht schlechter als 3, 3, 4 sein.
                          </p>
                      </div>
                  </div>
                  <div className="col-12 lg:col-3">
                      <div className={styles.label}>Unterricht</div>
                  </div>
                  <div className="col-12 lg:col-9">
                      <div className={styles.content}>
                          <p>Der Unterricht beträgt zwischen ca. 33 und 36 Wochenstunden, wobei der Schwerpunkt auf der beruflichen Ausbildung liegt.

                              Die traditionellen Fächer (Deutsch, Englisch, Mathematik, Politik und Wirtschaft) umfassen nur 3 bis 4 Wochenstunden. Allerdings verdoppelt sich die Stundenzahl im 2. Ausbildungsjahr, wenn man die zusätzliche Prüfung zum Fachabitur ablegen will. In den beruflichen Lernfeldern geht es um bürowirtschaftliche Arbeitsabläufe, Geschäftskorrespondenz, Position von Unternehmen am Markt, Personalvorgänge, Teamarbeit und anderes. Die Arbeit mit und am Computer ist ebenso wichtig wie das Erlernen von Wirtschaftsenglisch.
                          </p>
                      </div>
                  </div>
                  <div className="col-12 lg:col-3">
                      <div className={styles.label}>Abschluss</div>
                  </div>
                  <div className="col-12 lg:col-9">
                      <div className={styles.content}>
                          <p>Die Ausbildung endet mit der Prüfung zum staatlich geprüften kaufmännischen Assistenten für Bürowirtschaft. Mit einer Zusatzprüfung kann auch die Fachhochschulreife (Fachabitur) erworben werden. Damit ist auch der Weg frei zur Fachhochschule oder Universität (Bachelor-Studiengänge).</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  )
}
export default HHereBerufsfachschule;